/* Finance slider: estimated monthly payment calculator (homepage finance section). */
(function () {
  function money(n) {
    return "£" + Math.round(n).toLocaleString("en-GB");
  }
  function monthly(amount, rate, months) {
    var r = (rate / 100) / 12;
    if (!r) return amount / months;
    return (amount * r) / (1 - Math.pow(1 + r, -months));
  }
  function init(root) {
    if (root.dataset.pmbCalcReady) return;
    root.dataset.pmbCalcReady = "1";
    var range = root.querySelector("[data-pmb-calc-range]");
    var costEl = root.querySelector("[data-pmb-calc-cost]");
    var monthlyEl = root.querySelector("[data-pmb-calc-monthly]");
    var subEl = root.querySelector("[data-pmb-calc-sub]");
    var termsEl = root.querySelector("[data-pmb-calc-terms]");
    if (!range || !monthlyEl) return;
    var rate = parseFloat(root.dataset.rate || "11.9");
    var terms = (root.dataset.terms || "36,48,60,84,120").split(",").map(function (t) {
      return parseInt(t.trim(), 10);
    }).filter(function (t) { return t > 0; });
    var term = parseInt(root.dataset.defaultTerm || terms[terms.length - 1], 10);

    if (termsEl) {
      termsEl.innerHTML = "";
      terms.forEach(function (t) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "pmb-chip";
        b.textContent = t + " mo";
        b.setAttribute("aria-pressed", t === term ? "true" : "false");
        b.addEventListener("click", function () {
          term = t;
          Array.prototype.forEach.call(termsEl.children, function (c) {
            c.setAttribute("aria-pressed", c === b ? "true" : "false");
          });
          update();
        });
        termsEl.appendChild(b);
      });
    }

    function update() {
      var amount = parseFloat(range.value) || 0;
      var pct = (amount - range.min) / (range.max - range.min) * 100;
      range.style.setProperty("--pmb-range-pct", pct + "%");
      if (costEl) costEl.textContent = money(amount);
      monthlyEl.textContent = money(monthly(amount, rate, term));
      if (subEl) subEl.textContent = "over " + term + " months at " + rate + "% p.a. fixed";
    }
    range.addEventListener("input", update);
    update();
  }
  function boot() {
    document.querySelectorAll("[data-pmb-calc]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
